import { createRouter, createWebHashHistory } from "vue-router";
import Custom from "../views/Custom.vue";
import ConfigurationList from "@/views/ConfigurationList.vue";
import User from "@/views/User.vue";
import OrderDetail from "@/views/OrderDetail.vue";

const routes = [
  {
    path: "/",
    name: "custom",
    meta: {
      title: "定制",
      keepAlive: true,
    },
    component: Custom,
  },
  {
    path: "/configuration-list",
    name: "configuration-list",
    meta: {
      title: "结算",
    },
    component: ConfigurationList,
  },
  {
    path: "/user",
    name: "user",
    meta: {
      title: "个人中心",
      keepAlive: true,
    },
    component: User,
  },
  {
    path: "/order-detail",
    name: "orderDetail",
    meta: {
      title: "订单详情",
      keepAlive: false,
    },
    component: OrderDetail,
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

// 全局前置守卫，用于更新页面标题
router.beforeEach((to, from, next) => {
  // 如果路由有title属性，则更新文档标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else if (to.title) {
    // 兼容直接在路由对象上定义的title属性
    document.title = to.title;
  }
  next();
});

// // 全局后置钩子，处理路由错误
// router.afterEach((to, from) => {
//   // 记录路由跳转
//   console.log(`路由跳转: ${from.path} -> ${to.path}`);
// });

// 全局错误处理
router.onError((error) => {
  console.error("路由错误:", error);
  // 可以在这里添加错误处理逻辑，比如跳转到错误页面
});

export default router;
